import { request } from '../../utils/request';
import axios from 'axios';

export async function getActiveRound() {
  return request({
    url: '/super_brain/active_round',
  });
}

export async function getAirDropItem(id) {
  return axios({
    url: process.env.VUE_APP_1155_TOKEN_URL + '/' + id + '.json',
    method: 'get',
  })
}

export async function getRoundRanking() {
  return request({
    url: '/super_brain/ranking?stage=2',
    method: 'get',
  });
}
